import { Nullable, Optional } from 'common/models/optional';
import { OutboundLink } from 'gatsby-plugin-google-gtag';
import React, { PropsWithChildren } from 'react';
import { InputUtils } from 'utils/inputUtils';

type Props = {
  href: Nullable<string> | Optional<string>;
};

export const OptionalOutboundLink: React.FC<Props & PropsWithChildren> = ({
  href,
  children,
}) => {
  if (!href || !InputUtils.isTruthy(href)) {
    return <>{children}</>;
  }
  return (
    <OutboundLink target="_blank" href={href}>
      {children}
    </OutboundLink>
  );
};
